import { render, staticRenderFns } from "./MintalMesPrdPelletizingProductTreatmentParameterEdit.vue?vue&type=template&id=8335b6ac&"
import script from "./MintalMesPrdPelletizingProductTreatmentParameterEdit.vue?vue&type=script&lang=js&"
export * from "./MintalMesPrdPelletizingProductTreatmentParameterEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports